"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {};
tokens._getCss = function () {return `/* imported from run.css */ body { margin: 0; padding: 0; max-width: 100vw; overflow-x: hidden; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/components/App/run_css.js"};
exports["default"] = tokens;